import entityicon from './entity.png'
import { lazy, Suspense, useRef, useState } from 'react'
import { useProxy } from 'valtio/macro'
import { routerStore, loginStore, quoteDataRec, AgmodalStore } from './state/CommonState'
import Quote from './Quote'
import TestForm from './TestForm'
import { useGlobalState } from './GlobalState'
import { configStore } from './state/CommonState'
import AgModal from './components/AgModal'
import { subscribe, useSnapshot } from 'valtio'
import { useEffect } from 'react'
import Api from './state/Api'
import EditAguser from './agusers/edit-aguser'
import AguserApi from './state/AguserApi'
import MyProfile from './agusers/my-profile'
import MyProfileNew from './agusers/my-profile-new'
import AcceptRegistration from './agusers/accept-registration'
import { AgSelect } from './components/AgComponents'
import OperatingCompany from './components/operating-company'
import { menucountStore } from './state/menuStore'
import { tourStore } from './tourStore'
import { AgNavBar } from './mui-components/AgNavBar'
import RoleUtils from './util/RoleUtils'
import { PERMISSIONS, PERMISSIONS_NEW } from './util/constants'
import MobileAppTemp from './MobileAppTemp'
import Utils from './util/Utils'
import { enquiryStore } from './enquiry/enquiry-data'
import menuList from './menus'
import { isCrmUser, isStaffHomeUser } from './home/staff-home-user'
import { ServerLists } from './StaticData'
import { cartingStore } from './cartingorder/cartingStore'
import ChatWidget from './ai_integrations/openai'
import Draggable from 'react-draggable'
import { useMobile } from './hooks/usemobile'
import { Box } from '@mui/material'
import { truckLoader, LottieAnimation } from './mui-components/TruckLoader'
const Layout = lazy(()=>import("./pages/Layoutpage").then(module=>({default:module.Layout})))
const MobileMainLayout = lazy(()=>import("./pages/mobile/main").then(module=>({default:module.MobileMainLayout})))

function Navbar() {
    const { leftMenuHidden, setLeftMenuHidden, changeCurrentMenu } = useGlobalState()
    useSnapshot(loginStore)
    useSnapshot(tourStore)
    const logo = `/assets/${process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE}/nav_logo.png`
    const [NotificationData, setNotificationData] = useState([])
    const [NotificationCount, setNotificationCount] = useState(0)
    const [showBox, setshowBox] = useState(false)
const handleChildData = (data) => {
    setNotificationCount(data);
  };
const toggleshowBox = (data) => {
    setshowBox(data);
  };
    // useEffect(() => {
    //     deleteToken(messaging)
    //      getToken(messaging, { vapidKey:'BEIjTopwCc4XIvqnXQtSgACWAIx9tBfmSlS4ldc4Hm4qAnM6s-2lXbDTIe9tzFO4us9SPE9xaKgB-iKiNhWJNOk'})
    //         .then(token => {
    //             let obj = {
    //                 token: token,
    //                 email: loginStore?.userRec?.email || ''
    //             }
    //             Api.registerTokens(obj, (data) => {
    //                 console.log("tpken",data);
                    
    //             })
    //             console.log('token', token);
    //         }).catch(console.error);
    // let obj2 = {
    //   status: 'unread',
    //   email: loginStore?.userRec?.email || ''
    // }
    //     Api.getNotifications(obj2, (data) => {
    //         setNotificationCount(data?.length || 0)
    //     })
    //     const unsubscribe = onMessage(messaging, (payload) => {
    //         console.log("Message received in foreground:", payload);
    //         const notification = new Notification(payload.notification.title, {
    //             body: payload.notification.body,
    //             icon: payload.notification.icon,
    //         });
    //         const notificationOptions = {
    //             body: payload.notification.body,
    //             data: {
    //                 click_action: payload.fcmOptions?.link || payload.webpush?.fcmOptions?.link || "/"
    //             }
    //         };
    //         notification.onclick = (event) => {
    //             event.preventDefault();
    //             const url = notificationOptions.data.click_action;
    //             if (url) window.open(url, "_blank");
    //         };
    //     });

    //     return () => unsubscribe();
    // }, []);
    let menuToggleClass = leftMenuHidden ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left'
    return (
        <nav className='navbar has-shadow is-dark' style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
            <div className='navbar-brand'>
                <div className='navbar-item'>

                    <span className="icon is-small" onClick={() => setLeftMenuHidden(!leftMenuHidden)}>
                        <i className={menuToggleClass}></i>
                    </span>

                </div>
                <a className='navbar-item'>
                    <img src={logo} />
                </a>
                <div className="navbar-burger">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className='navbar-menu'>
                <div className="navbar-start">
                    <div className="navbar-item">
                        <small>NAVIGATING BORDERS WITH EXCELLENCE</small>
                    </div>

                </div>
                <div className="navbar-end" style={{ paddingRight: '5rem' }}>
                    {
                        (loginStore?.userRec?.aguserRec?.tour == 'no' && loginStore?.userRec?.aguserRec?.email.indexOf(`${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)==-1)?<a className="navbar-item" onClick={()=>{
                            tourStore.enable = true
                            tourStore.show = true
                            let d = JSON.parse(localStorage.getItem('ag_userrec'))
                            d.aguserRec.tour = 'yes'
                            d = JSON.stringify(d)
                            localStorage.setItem('ag_userrec',d)
                            loginStore.userRec.aguserRec.tour = 'yes'
                            let data = {email:loginStore.userRec.email,tour:"yes"}
                            AguserApi.updatetour(data)
                        }}>Show Tour</a>:""
                    }
                    {
                        (loginStore.isClient()) ? <OperatingCompany /> : <></>
                    }
                   {/* <div style={{position:'relative',width:'100px',display:"flex",alignItems:'center',justifyContent:'center'}}>
                    <span className="icon " style={{
                            position: 'relative',
                            display: 'inline-block',
                            fontSize: '24px'
                    }} onClick={()=> setshowBox(!showBox)}>
                    <i class="fa-regular fa-bell" style={{fontSize:'22px'}}></i>
                     <span class="badge" style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '-8px',
                                padding: '0 5px',
                                borderRadius: ' 50%',
                                background: '#eea724',
                                color: '#000',
                                fontSize: '12px',
                                fontWeight:'bolder'
                     }}>{NotificationCount}</span>
                    </span>
                     {showBox && <Notifications NotificationData = {NotificationData} sendDataToParent={handleChildData} toggleshowBox = {toggleshowBox}/>}
                    </div> */}
                        
                    <div className="navbar-item has-dropdown is-hoverable tour2" onMouseOver={()=>tourStore.changestep(tourStore.step)}>
                        <div className={"navbar-link"+ (tourStore.step==4 && tourStore.enable ? ' is-active' : '')}  >
                            {loginStore.userRec.firstName} {loginStore.userRec.lastName}
                            <span className="icon is-small" style={{ marginLeft: '5px' }}>
                                <i className="fa-regular fa-user"></i>
                            </span>
                        </div>
                        <div className="navbar-dropdown tour3" style={{display: tourStore.step==4 && tourStore.enable ? 'block' : ''}}>
                            <a className="navbar-item " onClick={() => {
                                tourStore.nextstep()
                                // AguserApi.getUser(loginStore.email)
                                configStore.currentMainComponent = <MyProfileNew />

                            }}>
                                <div>
                                    <span className="icon ">
                                        <i className="fa fa-user-circle"></i>
                                    </span>
                                    <span className='ml-2'>Profile</span>
                                </div>
                            </a>
                            <a className="navbar-item" onClick={() => {
                                let token = localStorage.getItem("devicetoken")
                                let d = JSON.parse(localStorage.getItem("ag_userrec"))
                                if(!d){
                                    loginStore.reinitialize()
                                    localStorage.removeItem('ag_email')
                                    localStorage.removeItem('tour')
                                    localStorage.removeItem('ag_current_entity')
                                    localStorage.removeItem('ag_userrec')
                                    localStorage.removeItem('devicetoken')
                                }else{
                                    AguserApi.logout({token:token,email:d.email},()=>{
                                        console.log("logout")
                                    })
                                }
                                // loginStore.reinitialize()
                                // localStorage.removeItem('ag_email')
                                // localStorage.removeItem('ag_userrec')
                            }}>
                                <div>
                                    <span className="icon is-small">
                                        <i className="fa fa-sign-out"></i>
                                    </span>
                                    <span className='ml-2'>Sign Out</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}
function menuFilter(e) {
    if(e?.isRoleBased) {
        let showCB = false, showDT=false
        const getRoleBasedChildKeys = (menuName) => {
            return menuList.find(menu => menu.name === menuName)?.children
                ?.filter(child => child.isRoleBased)
                ?.map(child => child.key) || []
        }

        const crossBorderChildrenKeys = getRoleBasedChildKeys('Cross-Border')
        const domesticTransportChildrenKeys = getRoleBasedChildKeys('Domestic Transport')
        for (const key of crossBorderChildrenKeys) {
            switch (key) {
              case 'Upload Schedulesv3':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOAD_SCHEDULE.VIEW_NAVBAR)) showCB = true;
                break;
              case 'Enquiriesv3':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.VIEW_NAVBAR)) showCB = true;
                break;
              case 'Quotationv3':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.VIEW_NAVBAR)) showCB = true;
                break;
              case 'Bookingsv3':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.VIEW_NAVBAR)) showCB = true;
                break;
              case 'Visibility':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.VIEW_NAVBAR)) showCB = true;
                break;
              case 'My Actions':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.MY_ACTIONS.VIEW_NAVBAR)) showCB = true;
                break;
              case 'Spot Booking WIP':
                showCB = true;
                break;
              case 'Carting Photos':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CARTING_SHEET.VIEW_NAVBAR)) showCB = true;
                break;
            }
          }

          for (const key of domesticTransportChildrenKeys) {
            switch (key) {
              case 'Domestic Quotations':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL)) showDT = true;
                break;
              case 'Domestic Transport Booking':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL)) showDT = true;
                break;
              case 'Domestic Transport Actions':
                if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL)) showDT = true;
                break;
            }
          }

        switch(e.key) {
            case 'Upload Schedulesv3':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOAD_SCHEDULE.VIEW_NAVBAR);
            case 'Users':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.USERS.VIEW_NAVBAR);
            case 'Enquiriesv3':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.VIEW_NAVBAR);
            case 'Quotationv3':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.VIEW_NAVBAR);
            case 'Bookingsv3':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.VIEW_NAVBAR);
            case 'Visibility':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.VIEW_NAVBAR);
            case 'My Actions':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.MY_ACTIONS.VIEW_NAVBAR);
            case 'Console Planning':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CONSOLE_PLANNING.VIEW_NAVBAR);
            case 'Carting Sheet':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CARTING_SHEET.VIEW_NAVBAR);
            case 'Carting Photos':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CARTING_SHEET.VIEW_NAVBAR);
            case 'Manage CRM':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENTITIES.VIEW_NAVBAR) || RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CARTING_SHEET.VIEW_NAVBAR);
            case 'Master Job':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.MASTER_JOB.VIEW_NAVBAR);
            case 'RateRequestapproval':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.VIEW_NAVBAR);
            case 'RateRequest':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.VIEW_NAVBAR);
            case 'Quotationvapproval':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATIONS_APPROVAL.VIEW_NAVBAR);
            case 'Visibility Dashboard':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY_DASHBOARD.VIEW_DASHBOARD);   
            case 'Finance Dashboard':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.FINANCE_DASHBOARD.VIEW_DASHBOARD); 
            case 'Data Discrepancies':
                return isStaffHomeUser();
            case 'CRM Analytics':
                return isCrmUser();
            case 'Domestic Quotations':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL);
            case 'Domestic Transport Booking':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL);
            case 'Domestic Transport Actions':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DOMESTIC_TRANSPORT.ALL);
            case 'Config':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CONFIG.VIEW_NAVBAR);
            case 'Schedules':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.SCHEDULES.VIEW_NAVBAR);
            case 'Uploads':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOADS.VIEW_NAVBAR);
            case 'Reports':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.REPORTS.VIEW_NAVBAR);
            case 'Devices':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ACCESS_CONTROL.VIEW_NAVBAR);
            case 'Entitiesv2':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENTITIES.VIEW_NAVBAR);
            case 'Vehicle List':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VEHICLES.VIEW_NAVBAR);
            case 'Drivers List':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DRIVERS.VIEW_NAVBAR);
            case 'Audit':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.AUDIT.VIEW_NAVBAR);
                // return process.env.REACT_APP_AUDIT && JSON.parse(process.env.REACT_APP_AUDIT).includes(loginStore?.email);
            case 'Site-Information':
                return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.SITE_INFORMATION);
            case 'Home':
                // return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.HOME);
                // return configStore.homeUsersList?.length > 0 ? configStore.homeUsersList?.includes(loginStore?.email) : false
                return configStore.homeUsersList?.includes(loginStore?.email)
            // case 'Operations CB':
            //     return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.OPERATIONS_CB);
            // case 'Sales CB':
            //     return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.SALES_CB);
            case 'Approvals':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.APPROVALS.VIEW_NAVBAR);
            case 'FCL Pricing':
                return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.ANALYTICS_FCL_PRICING);
            case 'Operations CB':
                return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.REMAINING_ANALYTICS);
            case 'Sales CB':
                return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.REMAINING_ANALYTICS);
            case 'Roles':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ROLES.VIEW_NAVBAR);
            case 'Customers':
                //commenting for testing purpose, it should only display for production URL
                // if(Utils.isProductionURL())
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CUSTOMERS.VIEW_NAVBAR)
            case 'AI Overriding':
                return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.AI_OVERRIDING.VIEW_NAVBAR);
            case '':
                if(e.name === 'Cross-Border'){
                    return showCB
                } else if (e.name === 'Domestic Transport'){
                    return showDT
                } else if(e.name === 'Analytics'){
                    return RoleUtils.isUserAuthorized(PERMISSIONS.NAV_MENU.ANALYTICS);
                }
                else {
                    return false;
                }
            default:
                return true;
        }

    } else if (e?.exclude && !e?.isRoleBased) {
        if (e?.exclude.indexOf(loginStore.userRec.aguserRec.role) >= 0) {
            return false
        }
    }
    else if( e?.excludeMenu && configStore?.currentSelectedEntity?.isTrackMyBooking !== "Yes"){
        return false
    }
    return true
}

const MENU_META = {
    "Manage CRM": {
        subtitle: "Accounts and Meetings",
        iconBg: "bg-[#FFF7ED] text-[#2E3A94]",
        icon: (
            <svg className="w-5 h-5 text-[#EA580C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        ),
    },
    "Carting Photos": {
        subtitle: "Upload Photos and videos",
        iconBg: "bg-[#EEF2FF] text-[#2E3A94]",
        icon: (
            <svg className="w-5 h-5 text-[#2E3A94]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
        ),
    },
    "Carting Sheet": {
        subtitle: "Carting orders & cargo",
        iconBg: "bg-[#EFF6FF] text-[#2E3A94]",
        icon: (
            <svg className="w-5 h-5 text-[#2E3A94]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <rect width="18" height="18" x="3" y="3" rx="2" strokeWidth="2" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9h18M9 21V9" />
            </svg>
        ),
    },
    "Quick Quote": {
        subtitle: "Spot booking & rates",
        iconBg: "bg-[#FFF7ED] text-[#EA580C]",
        icon: (
            <svg className="w-5 h-5 text-[#EA580C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
        ),
    },
};

export function Leftmenu() {
    useSnapshot(menucountStore)
    useSnapshot(cartingStore)
    let mc = menucountStore
    const isMobile = useMobile();
    const [check, setCheck] = useState(false)
    useEffect(() => {
        //Api.getmenucount()
        let unsubscribe = subscribe((menucountStore, configStore.currentSelectedEntity), () => {
            mc = menucountStore
        })
        return unsubscribe
    }, [menucountStore, configStore.currentSelectedEntity])

    if (!check) {
        setCheck(true)
        // Api.getmenucount()
    }
    const checkpermission = (keyname)=>{
        switch (keyname) {
            // case "Site-Information":
            //     return (process.env.REACT_APP_SITEINFORMATION!=undefined && JSON.parse(process.env.REACT_APP_SITEINFORMATION).indexOf(loginStore.email) != -1)?true:false
            // case "Analytics":
            //     return ((process.env.REACT_APP_SALES_CB!=undefined && JSON.parse(process.env.REACT_APP_SALES_CB).indexOf(loginStore.email) != -1) || (process.env.REACT_APP_OPEARTIONS_CB!=undefined && JSON.parse(process.env.REACT_APP_OPEARTIONS_CB).indexOf(loginStore.email) != -1))?true:false
            // case "Opeartions CB":
            //     return (process.env.REACT_APP_OPEARTIONS_CB!=undefined && JSON.parse(process.env.REACT_APP_OPEARTIONS_CB).indexOf(loginStore.email) != -1)?true:false
            // case "Sales CB":
            //     return (process.env.REACT_APP_SALES_CB!=undefined && JSON.parse(process.env.REACT_APP_SALES_CB).indexOf(loginStore.email) != -1)?true:false
            // case "Home":
            //     return (process.env.REACT_APP_HOME!=undefined && JSON.parse(process.env.REACT_APP_HOME).indexOf(loginStore.email) != -1)?true:false
            // case "Uploads":
            //     return (process.env.REACT_APP_UPLOADS!=undefined && JSON.parse(process.env.REACT_APP_UPLOADS).indexOf(loginStore.email) != -1)?true:false
            // case "Audit":
            //     return (process.env.REACT_APP_AUDIT!=undefined && JSON.parse(process.env.REACT_APP_AUDIT).indexOf(loginStore.email) != -1)?true:false
            default:
                return false
        }
    }
    const checkskip = (keyname)=>{
        if(loginStore.isClient()) return true
        // if(["Site-Information","Analytics","Opeartions CB","Sales CB","Home","Uploads","Audit"].indexOf(keyname) == -1){return true}else{return false}
        // if([].indexOf(keyname) == -1){return true}else{return false}
        return true;
    }

    let { menuList, clientMenuList, currentMenu, changeCurrentMenu } = useGlobalState()
    if (loginStore.isClient()) menuList = clientMenuList
    if (loginStore.isClient()) mc.Visibility = 0

    return isMobile ? (
        <nav className="w-full">
            <ul className="p-4 flex flex-col gap-3.5">
                {(loginStore.userRec.aguserRec.status === 'ACTIVE') ? (
                    menuList.find((menu) => menu.name === 'Cross-Border')?.children.filter(menuFilter).map((menu1) => {
                        if (!menu1.isMobileView) return null;
                        const isPermitted = ((checkpermission(menu1.name) && !checkskip(menu1.name)) ||
                            (!checkpermission(menu1.name) && checkskip(menu1.name)));
                        if (!isPermitted) return null;

                        const isActive = menu1.key === currentMenu;
                        const meta = MENU_META[menu1.name] || {};
                        const count = mc[menu1.key?.replace(/ /g, '')];
                        const countText = (count !== undefined && count !== 0) ? ` (${count})` : '';

                        return (
                            <li key={menu1.key || menu1.name}>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (menu1.key === "Spot Booking WIP" || menu1.key === "Spot Booking Streams") {
                                            enquiryStore.initialize();
                                            enquiryStore.rateRequestlist = [];
                                            cartingStore.current = JSON.parse(JSON.stringify({}));
                                            quoteDataRec.quotationNum = "";
                                            configStore.disableShipmentType = "";
                                            configStore.homescreenCurrentShipmentType = "LCL";
                                            configStore.homescreenCurrentShipmentScope = "Port-to-Port";
                                            enquiryStore.currentCargoTableKey = "" + new Date().getMilliseconds();
                                            enquiryStore.current.createdBy = loginStore.email;
                                            enquiryStore.current.gst = configStore.currentSelectedEntity.gst;
                                            enquiryStore.current.shipmentType = configStore.homescreenCurrentShipmentType;
                                            enquiryStore.current.countryFromEnquiry = "India";
                                        }
                                        changeCurrentMenu(menu1.key);
                                    }}
                                    className={`flex items-center justify-between p-4 rounded-xl transition-all duration-200 cursor-pointer ${
                                        isActive
                                            ? "bg-white border border-solid border-[#D0E2FF] shadow-[0_4px_12px_rgba(0,0,0,0.03)]"
                                            : "hover:bg-slate-50 border border-solid border-transparent hover:shadow-xs"
                                    }`}
                                >
                                    <div className="flex items-center gap-4">
                                        {/* Icon container */}
                                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform ${meta.iconBg || 'bg-[#EFF1FE] text-[#2E3A94]'}`}>
                                            <div className="relative w-5 h-5 flex items-center justify-center">
                                                {meta.icon ? (
                                                    meta.icon
                                                ) : menu1.mobileIcon ? (
                                                    <img src={menu1.mobileIcon} alt={menu1.name} className="w-5 h-5 object-contain" />
                                                ) : (
                                                    <svg className="w-5 h-5 text-[#2E3A94]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" />
                                                    </svg>
                                                )}
                                            </div>
                                        </div>

                                        {/* Text block */}
                                        <div className="flex flex-col text-left">
                                            <span className={`text-[15px] font-semibold tracking-wide transition-colors ${
                                                isActive ? "text-[#1E293B]" : "text-[#334155]"
                                            }`}>
                                                {menu1.name}{countText}
                                            </span>
                                            {meta.subtitle && (
                                                <span className="text-[12px] text-[#64748B] font-normal mt-0.5">
                                                    {meta.subtitle}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* Chevron indicator */}
                                    <svg
                                        className={`w-5 h-5 transition-transform ${
                                            isActive ? "text-[#2E3A94] translate-x-0.5" : "text-[#94A3B8]"
                                        }`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </li>
                        );
                    })
                ) : null}

                {/* Divider */}
                <hr className="border-t border-solid border-[#D2E3F7]/70 my-1 w-full" />

                {/* Logout / Sign Out Button */}
                <li>
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            if (truckLoader) truckLoader.open = true;
                            let token = localStorage.getItem("devicetoken");
                            let d = JSON.parse(localStorage.getItem("ag_userrec"));
                            if (!d) {
                                loginStore.reinitialize();
                                localStorage.removeItem('ag_email');
                                localStorage.removeItem('tour');
                                localStorage.removeItem('ag_current_entity');
                                localStorage.removeItem('ag_userrec');
                                localStorage.removeItem('devicetoken');
                                if (truckLoader) truckLoader.open = false;
                            } else {
                                AguserApi.logout({ token: token, email: d.email }, () => {
                                    console.log("logout");
                                    if (truckLoader) truckLoader.open = false;
                                });
                            }
                        }}
                        className="flex items-center justify-between p-4 rounded-xl transition-all duration-200 cursor-pointer hover:bg-slate-50 border border-solid border-transparent hover:shadow-xs"
                    >
                        <div className="flex items-center gap-4">
                            {/* Icon container with Quick Quote styling */}
                            <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform bg-[#FFF7ED] text-[#EA580C]">
                                <div className="relative w-5 h-5 flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#EA580C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                </div>
                            </div>

                            {/* Text block */}
                            <div className="flex flex-col text-left">
                                <span className="text-[15px] font-semibold tracking-wide text-[#EA580C]">
                                    Sign Out
                                </span>
                            </div>
                        </div>

                        {/* Chevron indicator */}
                        <svg
                            className="w-5 h-5 transition-transform text-[#94A3B8]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </li>
            </ul>
        </nav>
    ) : (
        <nav className='menu'  id='menu' style={{ padding: '0px', zoom: '0.9' }}>
            {/*<p className='menu-label' style={{color: 'white'}}>
                Menu
    </p>*/}
            <ul className="menu-list">
                {(loginStore.userRec.aguserRec.status === 'ACTIVE') ?
                    menuList.filter(menuFilter).map(menu => {
                        if (menu.isMobileOnly) return <></>
                        if (menu.children != undefined) {
                            return (
                                <>
                                    {
                                        ((checkpermission(menu.name) && !checkskip(menu.name)) ||
                                            (!checkpermission(menu.name) && checkskip(menu.name)))?<li key={menu.key} className={menu.classname+"-menu"}>
                                            <a className={menu.classname+"-menu"}style={{fontWeight: 'bold', fontStyle: 'italic', marginBottom: '0px'}}>
                                                {menu.name} {(mc[menu.key.replace(/ /g, '')] != undefined && mc[menu.key.replace(/ /g, '')] != 0) ? `(${mc[menu.key.replace(/ /g, '')]})` : ''}

                                            </a>
                                            <ul className="menu-list" style={{marginTop: '0px'}}>{
                                                menu.children.filter(menuFilter).map(menu1 => {
                                                    if (menu1.isMobileOnly) return <></>
                                                    let classname = ''
                                                    if (menu1.key === currentMenu) classname = 'is-active'
                                                    let menu1Style = {}
                                                    if (menu1.key === currentMenu) menu1Style = { backgroundColor: '#eea724', color: 'black' }
                                                    menu1Style.textAlign = 'left'
                                                    return (
                                                        <>
                                                            {
                                                                ((checkpermission(menu1.name) && !checkskip(menu1.name)) ||
                                                                    (!checkpermission(menu1.name) && checkskip(menu1.name)))?<li key={menu1.key} className={menu1.classname+"-menu"}>
                                                                    <a style={menu1Style} href={menu1.href}
                                                                        onClick={(e) => {
                                                                            AgmodalStore.modalPage = ""
                                                                            e.preventDefault()
                                                                            if(menu1.key=="Spot Booking WIP" || menu1.key=="Spot Booking Streams"){
                                                                                enquiryStore.initialize();
                                                                                enquiryStore.rateRequestlist = []
                                                                                cartingStore.current = JSON.parse(JSON.stringify({}))
                                                                                quoteDataRec.quotationNum = ""
                                                                                configStore.disableShipmentType = ""
                                                                                configStore.homescreenCurrentShipmentType = "LCL"
                                                                                configStore.homescreenCurrentShipmentScope = "Port-to-Port"
                                                                                enquiryStore.currentCargoTableKey = "" + new Date().getMilliseconds();
                                                                                enquiryStore.current.createdBy = loginStore.email;
                                                                                enquiryStore.current.gst = configStore.currentSelectedEntity.gst;
                                                                                enquiryStore.current.shipmentType = configStore.homescreenCurrentShipmentType;
                                                                                enquiryStore.current.countryFromEnquiry =  "India"
                                                                            }
                                                                            changeCurrentMenu(menu1.key)
                                                                        }}>
                                                                        {
                                                                            (menu1.key === 'Home') ?
                                                                                <span className="icon" style={{ marginRight: '5px' }}>
                                                                                    <i class="fa-solid fa-house"></i>
                                                                                </span>
                                                                                : <></>
                                                                        }
                                                                        {menu1.name} {(mc[menu1.key.replace(/ /g, '')] != undefined && mc[menu1.key.replace(/ /g, '')] != 0) ? `(${mc[menu1.key.replace(/ /g, '')]})` : ''}
                                                                    </a>
                                                                </li>:""}
                                                        </>
                                                    )
                                                })
                                            }

                                            </ul>
                                        </li>:""
                                    }
                                </>

                            )
                        } else {
                            let classname = ''
                            if (menu.key === currentMenu) classname = 'is-active'
                            let menuStyle = {}
                            if (menu.key === currentMenu) menuStyle = { backgroundColor: '#eea724', color: 'black' }
                            menuStyle.textAlign = 'left'
                            return (
                                <>
                                    {
                                        (checkpermission(menu.name))?<li key={menu.key} className={menu.classname+"-menu"}>
                                            <a style={menuStyle} href={menu.href}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    changeCurrentMenu(menu.key)
                                                }}>
                                                {
                                                    (menu.key === 'Home') ?
                                                        <span className="icon" style={{ marginRight: '5px' }}>
                                                            <i class="fa-solid fa-house"></i>
                                                        </span>
                                                        : <></>
                                                }
                                                {menu.name} {(mc[menu.key.replace(/ /g, '')] != undefined && mc[menu.key.replace(/ /g, '')] != 0) ? `(${mc[menu.key.replace(/ /g, '')]})` : ''}
                                            </a>
                                        </li>:''
                                    }
                                    {
                                        (checkskip(menu.name))?<li key={menu.key} className={menu.classname+"-menu"}>
                                            <a style={menuStyle} href={menu.href}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    changeCurrentMenu(menu.key)
                                                }}>
                                                {
                                                    (menu.key === 'Home') ?
                                                        <span className="icon" style={{ marginRight: '5px' }}>
                                                            <i class="fa-solid fa-house"></i>
                                                        </span>
                                                        : <></>
                                                }
                                                {menu.name} {(mc[menu.key.replace(/ /g, '')] != undefined && mc[menu.key.replace(/ /g, '')] != 0) ? `(${mc[menu.key.replace(/ /g, '')]})` : ''}
                                            </a>
                                        </li>:''
                                    }

                                </>

                            )
                        }

                    }) : <></>
                }
            </ul>
        </nav>
    )
}

function Content() {
    useSnapshot(configStore)
    const { leftMenuHidden, setLeftMenuHidden, menuList, currentMenu } = useGlobalState()
    let classnames = 'column is-2 '
    if (leftMenuHidden) classnames += 'is-hidden'
    if (loginStore.userRec.aguserRec.status !== 'ACTIVE') AguserApi.getUser(loginStore.userRec.email)
    return (
        <section className='section' style={{ paddingTop: '0px', marginTop: '0px' }}>
            <div className='columns'>
            { loginStore.isClient() ? <></> :  <div className={classnames} style={{
                    height: '95vh', overflow: 'auto',
                    backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR, borderRadius: '0px 0px 0px 0px', paddingTop: '2rem',paddingLeft:"1.5rem"
                }}>
                    <Leftmenu />
                </div>
            }
                <div className='column' style={{ height: '95vh', overflow: 'scroll', paddingTop: '1rem',overflowX:"hidden" }}>
                    <Suspense fallback={<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}><LottieAnimation /></Box>}>
                    {
                        //menuList.filter(menu => menu.key === currentMenu).map(menu => menu.component)
                        (loginStore.userRec.aguserRec.status === 'ACTIVE') ?
                            configStore.currentMainComponent :
                            <AcceptRegistration id={loginStore.userRec.email} />
                    }
                    </Suspense>
                </div>
            </div>
        </section>
    )
}

export default function Main() {
  const getExchangerates = async () => {
    await Api.getExchangerates();
    await Api.getDescriptionList()
    if (
      !loginStore.isClient() &&
      ((ServerLists.rolePermissionsList.length <= 0) ||
        ServerLists?.permissionsList?.length <= 0)
    ) {
      await Api.getRolesPermissions();
    }
  };

  useEffect(() => {
    getExchangerates();
  }, []);

  const isMobile = useMobile();

  

  return (
    <>
      {
        !isMobile ? (
          loginStore.isClient() ? (
            <Suspense fallback={<div>Loading...</div>}>
              <Layout />
            </Suspense>
          ) : (
            <>
              {loginStore.isClient()
                ? <AgNavBar setTabIndex={() => {}} selectedTabIndex={0} />
                : <Navbar />
              }
              <Content />
            </>
          )
        ) : (
         loginStore.isClient() ? <MobileAppTemp />
        : <MobileMainLayout/>
        )
      }
      {/* <Draggable>
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
        <ChatWidget />
      </div>
    </Draggable> */}
    </>
  );
}
